import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.22 6.45a1.9 1.9 0 0 0-1.43-.62H9.67l.4-2.14A2.1 2.1 0 0 0 8 1.25 2 2 0 0 0 6 3l-.56 2.83H2a.76.76 0 0 0-.75.75V14a.76.76 0 0 0 .75.75h10.24a2.09 2.09 0 0 0 2.09-1.89l.41-4.71a2.22 2.22 0 0 0-.52-1.7Zm-11.47.88H5.3v5.92H2.75Zm10.09 5.38a.6.6 0 0 1-.6.54H6.8V6.77l.64-3.51A.56.56 0 0 1 8 2.75a.6.6 0 0 1 .46.25.57.57 0 0 1 .13.47L8 6.44a.77.77 0 0 0 .16.62.75.75 0 0 0 .58.27h4a.41.41 0 0 1 .32.13.71.71 0 0 1 .13.54Z';
const draw24px =
  'M20.85,9.06A2.47,2.47,0,0,0,19,8.25H13.88l.47-2.79a2.75,2.75,0,0,0-2.71-3.21A2.68,2.68,0,0,0,9,4.5L8.37,8.25H3A.76.76,0,0,0,2.25,9V20a.75.75,0,0,0,.75.75H18.19a2.72,2.72,0,0,0,2.73-2.47h0l.6-7A2.9,2.9,0,0,0,20.85,9.06Zm-17.1.69h4.5v9.5H3.75ZM20,11.14l-.6,7a1.24,1.24,0,0,1-1.24,1.12H9.75V9.07l.72-4.33a1.18,1.18,0,0,1,1.17-1,1.25,1.25,0,0,1,.95.45,1.24,1.24,0,0,1,.28,1l-.61,3.67a.72.72,0,0,0,.17.61.73.73,0,0,0,.57.26h6a1,1,0,0,1,.73.31A1.35,1.35,0,0,1,20,11.14Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ThumbsUpIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'thumbsUp'),
) as IconWithRender;

ThumbsUpIcon.displayName = 'ThumbsUpIcon';
ThumbsUpIcon.propTypes = Icon.propTypes;
ThumbsUpIcon.renderIcon = (props) => <ThumbsUpIcon {...props} />;
export default ThumbsUpIcon;
